
/* LVT-8 CRO Scripts */
document.addEventListener('DOMContentLoaded', function() {

  /* --- Countdown Timer --- */
  function initCountdown() {
    const end = new Date();
    end.setDate(end.getDate() + 3);
    end.setHours(23,59,59,0);

    function update() {
      const now = new Date();
      const diff = end - now;
      if (diff <= 0) return;

      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      const el = (id) => document.getElementById(id);
      if (el('cro-days')) el('cro-days').textContent = String(d).padStart(2,'0');
      if (el('cro-hours')) el('cro-hours').textContent = String(h).padStart(2,'0');
      if (el('cro-mins')) el('cro-mins').textContent = String(m).padStart(2,'0');
      if (el('cro-secs')) el('cro-secs').textContent = String(s).padStart(2,'0');
    }
    update();
    setInterval(update, 1000);
  }
  initCountdown();

  /* --- Scroll Reveal --- */
  const reveals = document.querySelectorAll('.cro-reveal');
  if (reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(el => observer.observe(el));
  }

  /* --- Back to Top --- */
  const backTop = document.querySelector('.cro-back-top');
  if (backTop) {
    window.addEventListener('scroll', () => {
      backTop.classList.toggle('visible', window.scrollY > 600);
    });
    backTop.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});
